import Script from 'next/script';
import { useRouter } from 'next/router';

import { Routes } from '~/domains/common/constants/routes';

const SOCURE_DOCV_SDK_SRC = 'https://websdk.socure.com/bundle.js';
const SOCURE_DEVICE_RISK_SDK_SRC = 'https://sdk.dv.socure.io/latest/device-risk-sdk.js';

const isMarketsKycRoute = (route: string): boolean => {
  const marketsKycRoute = Routes.marketsVerification();

  return route === marketsKycRoute || route.startsWith(`${marketsKycRoute}/`);
};

export function SocureSdkScripts() {
  const { route } = useRouter();
  const isMarketsKyc = isMarketsKycRoute(route);

  if (!isMarketsKyc) {
    return null;
  }

  return (
    <>
      <Script src={SOCURE_DOCV_SDK_SRC} />
      <Script
        src={SOCURE_DEVICE_RISK_SDK_SRC}
        data-public-key={process.env.NEXT_PUBLIC_SOCURE_DEVICE_RISK_SDK_KEY}
      />
    </>
  );
}
